import React from "react";
import { Icons } from "../../shared/Icons";

export const LoadingState: React.FC = () => {
  return (
    <div className="space-y-8 animate-fade-in">
      <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-medium border border-gray-100 dark:border-slate-700 p-12 text-center">
        <div className="flex flex-col items-center gap-4">
          <Icons.Refresh sx={{ fontSize: 48 }} className="animate-spin text-gray-400 dark:text-slate-500" />
          <p className="text-xl font-medium text-gray-600 dark:text-slate-300">
            Carregando configurações...
          </p>
        </div>
      </div>
    </div>
  );
};
